import {connect} from 'react-redux';

import {Rb2b} from '../../components/header/components/Rb2b';

function mapState(state: any) {
  return {
    client: state.client.data,
    loading: state.rb2b.isLoading,
    latestEvent: state.rb2b.event,
  };
}

const actionCreators = {
};

export const Rb2bContainer = connect(mapState, actionCreators)(Rb2b);
